import { Routes } from '@angular/router';
import { creditRequestRoutes } from './features/credit-request/credit-request.routes';
import { ShellLayoutComponent } from './layouts/shell-layout/shell-layout.component';

export const appRoutes: Routes = [
  // Fuera del shell: estas pantallas traen su propio encabezado.
  {
    path: 'credit-request',
    children: creditRequestRoutes,
  },
  {
    path: '',
    component: ShellLayoutComponent,
    children: [
      {
        path: 'home',
        loadComponent: () =>
          import('./features/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'prestamo',
        loadChildren: () =>
          import('./features/loan/loan.routes').then((m) => m.loanRoutes),
      },
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      { path: '**', redirectTo: 'home' },
    ],
  },
];
